module.exports = __webpack_public_path__ + "img/jingying-banner.35d5e88a.png";